package com.appsyde.shared.modules.ticket.domain.model

data class SendResult(
    val status: String,
    val ticketId: String,
    val outboundMessageId: String,
    val providerMessageId: String,
    val providerThreadId: String
)
